import React, { useEffect, useState } from "react";
import { Button, Card } from "antd";
import loginBg from "../../utils/login-bg.png";
import blendLogo from "../../utils/Blue.png";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { msalConfig } from "../../config/MsalConfig";
import { fetchToken, getLoggedInUserDetails } from "../../services/Apis";
import { useUserContext } from "../../context/UserContext";
import { saveToStorage } from "../../services/storage";

const { Meta } = Card;

const LoginPage: React.FC = () => {
  const navigate = useNavigate(); // React Router hook for navigation
  const location = useLocation(); // Get current location
  const [searchParams] = useSearchParams(); // Get search params from the URL
  const { setUserContext } = useUserContext();

  const [loginError, setLoginError] = useState<string | null>(null); // State to store login error

  const handleNavigate = (path: string) => {
    navigate(path); // Navigate to /create-pricing page
  };
  // Function to handle login
  const handleLogin = async () => {
    setLoginError(null);
    window.location.href = `${msalConfig.auth.authority}/oauth2/v2.0/authorize?client_id=${msalConfig.auth.clientId}&response_type=code&redirect_uri=${msalConfig.auth.redirectUri}&scope=User.Read`;
  };

  useEffect(() => {
    // Check if the URL contains the code
    const code = searchParams.get("code");
    if (code) {
      // Fetch token from the backend server
      const getToken = async () => {
        const response: any = await fetchToken(code);
        if (!response.error) {
          saveToStorage("login_token", response.data.access_token); // Save token to local storage
          const userDetails: any = await getLoggedInUserDetails();
          if (userDetails.error_status === 401) {
            localStorage.removeItem("login_token");
            navigate("/auth-error");
          } else {
            saveToStorage("user_details", JSON.stringify(userDetails.data)); // Save token to local storage
            setUserContext(userDetails.data);
            navigate("/home");
          }
        } else {
          setLoginError("Failed to fetch token:" + response.detail); // Set login error
        }
      };
      getToken();
    }
  }, [location.pathname]);

  return (
    <div
      style={{
        background: `url(${loginBg}) no-repeat`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingRight: "50px",
      }}
    >
      <Card
        style={{
          width: 500,
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            padding: "50px",
            alignItems: "center",
            paddingBottom: "12px",
            paddingTop: "12px",
            marginBottom: "24px",
          }}
        >
          <div style={{ borderRight: "1px solid gray", paddingRight: "16px" }}>
            <img
              alt="Blend Logo"
              style={{
                width: "200px",
              }}
              src={blendLogo}
            />
          </div>
          <div style={{ marginLeft: "16px", marginTop: "12px" }}>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "32px",
                marginBottom: "4px",
              }}
            >
              Pricing App
            </div>
          </div>
        </div>
        <Meta
          title="Single sign on"
          description="Sign in with your Microsoft Account"
          className="mb-4"
        />
        <Button onClick={handleLogin} style={{ width: "80%" }}>
          SSO Login
        </Button>
        {loginError && <p className="mt-3 text-danger">{loginError}</p>}
        <div
          className="mt-4 mb-2 w-100 text-center"
          style={{ color: "#898989" }}
        >
          © Blend360 {new Date().getFullYear()}
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
